import React, {useState, useEffect} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {useParams} from 'react-router-dom'
import {BulkOrderForm} from './components/BulkOrderForm'
import SidePane from './components/SidePane'
import {SupplierOperation } from '../core/_models'
import {getSupplierOperation } from '../core/_requests'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}, {
  title: 'Suppliers',
  path: '/p2c/supplier/list',
}, {
  title: 'Operations',
  path: '/p2c/supplier/operations',
}])


const BulkOrderWrapper = () => {
  const {id: orderId} = useParams()
  const [order, setOrder] = useState<SupplierOperation | undefined>()
  const [priceDigits, setPriceDigits] = useState<number>(2)
  const [contacts, setContacts] = useState<Array<string>>([])

  const load = async () => {
    const res = await getSupplierOperation(orderId)

    void(res && setOrder(res))
  }

  useEffect(() => {
    if (orderId && !order) {
      load()
    }
  })

  if (orderId && !order) {
    return (<></>)
  }

  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>
        {order ? 'Bulk Order ' + order.reference : 'Create new bulk order'}
      </PageTitle>
      <div className="card">
        <div className="card-body p-lg-20">
          <div className="d-flex flex-column flex-xl-row">
            <div className="flex-lg-row-fluid me-xl-18 mb-10 mb-xl-0">
              <div className="mt-n1">
                <BulkOrderForm
                  order={order}
                  setOrder={setOrder}
                  setPriceDigits={setPriceDigits}
                  setContacts={setContacts}
                />
              </div>
            </div>
            {order && (
              <SidePane
                order={order}
                setOrder={setOrder}
                priceDigits={priceDigits}
                contacts={contacts}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default BulkOrderWrapper
